"use client";
import { useSelector, useDispatch } from "react-redux";

import { triggerInfoBarOpened, handleStickyContent } from "@/src/store/stickyInfoBar";

import { infoAddToListing, infoRemoveToListing } from "constants/favorite";

import { removeFavoriteListing, addListingToFavoriteGroup } from "services/favorites";
import { handleListingFavorited, handleLastRemovedGroupInfo } from "@/src/store/favorite";

import CheckIcon from "assets/svg/radial_check.svg";

import StickyInfoBar from "components/common/sticky-info-bar";

const StickyInfoBarWrapper = () => {
  const dispatch = useDispatch();
  const stickyBarReduxState = useSelector((state) => state.stickyInfoBar.isOpened);
  const stickyBarContentReduxState = useSelector((state) => state.stickyInfoBar.content);
  const stickyBarBackButtonVisibilityReduxState = useSelector((state) => state.stickyInfoBar.isBackButtonVisible);
  const isFavoritedListingReduxState = useSelector((state) => state.favorite.isFavoritedListing);
  const lastRemovedFavoriteReduxState = useSelector((state) => state.favorite.lastRemovedGroupInfo);
  const listingIdReduxState = useSelector((state) => state.listingDetail.listingId);

  const handleStickyBackButton = async () => {
    if (isFavoritedListingReduxState) {
      try {
        const response = await removeFavoriteListing(listingIdReduxState);
        if (response.status === "success") {
          dispatch(handleListingFavorited(false));
          dispatch(handleLastRemovedGroupInfo(response.result));
          dispatch(handleStickyContent(infoRemoveToListing(response.result?.title)));
          dispatch(triggerInfoBarOpened());
        }
      } catch (error) {
        console.error(`Error for removing from favorite list! ${error}`);
      }
    } else {
      try {
        const response = await addListingToFavoriteGroup(lastRemovedFavoriteReduxState.id, listingIdReduxState);
        if (response.status === "success") {
          dispatch(handleListingFavorited(true));
          dispatch(handleStickyContent(infoAddToListing(lastRemovedFavoriteReduxState.title)));
          dispatch(triggerInfoBarOpened());
        }
      } catch (error) {
        console.error(`Add item to favorite list error!! ${error}`);
      }
    }
  };

  return (
    <StickyInfoBar
      isOpened={stickyBarReduxState}
      icon={<CheckIcon />}
      actionText={stickyBarBackButtonVisibilityReduxState ? `Geri Al` : null}
      handleActionButton={() => handleStickyBackButton()}
      content={stickyBarContentReduxState}
    />
  );
};

export default StickyInfoBarWrapper;
